import { PostFormRequest, PutFormRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useGetSelection } from "./useGetSelection"
import { SelectionEntity } from "../../Objects/Selection/SelectionEntity"
import { useTranslation } from "react-i18next"

export const useSaveSelection = () => {
  const { t } = useTranslation("general")
  const { enableLoad, disableLoad } = useLoad()
  const { setError } = useError()
  const { handleGetSelection } = useGetSelection()

  const handleSaveSelection = async (selection: SelectionEntity, onSuccess: any) => {
    try {
      enableLoad()

      const response =
        selection.id !== -1
          ? await PutFormRequest(`${API_ROUTES.SELECTION.PUT}/${selection.id}`, selection.toJSON())
          : await PostFormRequest(API_ROUTES.SELECTION.CREATE, selection.toJSON())

      if (response.success) {
        await handleGetSelection(onSuccess)
        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return { handleSaveSelection }
}
